import React from 'react';
import { Row, Button, Popover, PopoverBody } from 'reactstrap';


const buttonContainerStyle = {
	paddingBottom: '1rem',
};

const FundraiserButton = ({
	openModal, theme, buttonStyle, fundraiserUrl, showPopover, togglePopOver, ngo, width, isVolunteeringReferrer, showPopoverAfterDelay
}) => {
	let isPopOverOpen = isVolunteeringReferrer ? 'open' : 'close';
	if (typeof fundraiserUrl !== 'undefined') {
		return (
			<Row style={buttonContainerStyle} className="d-flex justify-content-center w-100">
				<a href={`/${fundraiserUrl}#openShareModal=true`} className="w-100" style={{
					marginRight: '1.25rem', marginLeft: '1.25rem', ...buttonStyle, fontSize: '20px',
				}}>
					<Button
						onClick={() => {
							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync('click_goto_fundraiser', {}, {amplitude: true});
							}
						}}
						color="fundraiser"
						className={`btn-full-width ${theme}-give-now w-100`}
						style={{
							...buttonStyle, fontSize: '20px',
						}}
					>
						go to your campaign
					</Button>
				</a>
			</Row>

		);
	}
	return (
		<React.Fragment>
				<Row style={buttonContainerStyle} className={`fundraiser-btn-popver-${isPopOverOpen} d-flex justify-content-center w-100`}>
					<Button

						id="btn_fundraiser"
						color="fundraiser"
						className={`btn-full-width ${theme}-give-now`}
						onClick={() => openModal('')}
						style={{
							 ...buttonStyle, fontSize: '20px',
						}}
					>
						start a campaign
					</Button>
					{window && showPopoverAfterDelay ? <Popover placement="auto" isOpen={showPopover} target="btn_fundraiser" toggle={togglePopOver} style={{ zIndex: 10 }}>
								<PopoverBody>
									Volunteer for {ngo} by creating a campaign to raise support from your friends and family.
							</PopoverBody>
					</Popover> : null
					}
					</Row>



			<style global jsx>
				{
					`
						@media(max-width: 576px) {
							.fundraiser-btn-popver-open {
								position: fixed;
								bottom: 5px;
								background-color: white;
								border-top: 1px solid transparent;
								z-index: 999;
								height: 55px;
								left: 0;
								bottom: 0;
								padding-bottom: 0 !important;
							}

							#btn_fundraiser  {
								height: ${isVolunteeringReferrer ? '45px' : '65px'};
								margin-right:  ${isVolunteeringReferrer? '0.25rem' : '1.25rem'} !important;
								margin-left:  ${isVolunteeringReferrer? '0.25rem' : '1.25rem'} !important;
							}

							.popover {
								z-index: 10000 !important;
							}
						}

						@media(min-width: 576px) {
							#btn_fundraiser {
								height: 65px;
								margin-right: 1.25rem;
								margin-left: 1.25rem;
							}
						}
					`
				}
			</style>
		</React.Fragment>

	);
};

export default FundraiserButton;
